<script setup lang="ts">
  import { ref, onUnmounted, watch } from 'vue';

  import { timerStore, type Timer, type TimerFrequency } from '@bv/stores/timer';

  export interface Props {
    startTime?: number | string;
    frequency?: TimerFrequency;
  }

  const props = withDefaults(defineProps<Props>(), {
    startTime: undefined,
    frequency: 1,
  });

  const store = timerStore();

  const timer = ref<Timer | null>(null);

  timer.value = store.registerTimer(props.startTime, props.frequency);

  watch(
    () => props,
    () => {
      if (timer.value) {
        store.unregisterTimer(timer.value.id);
      }

      timer.value = store.registerTimer(props.startTime, props.frequency);
    },
    { deep: true, immediate: true },
  );

  onUnmounted(() => {
    if (timer.value) {
      store.unregisterTimer(timer.value.id);
    }
  });
</script>

<template>
  <div class="timer">
    {{ timer?.duration }}
  </div>
</template>
